import { ApiResult } from "../models/ApiResult";
import { setInfoMessage, setWarningMessage } from "../store/alerts/alertsActions";
import { splitApiInfoMessages } from "../utils/apiInfoMessages";

export const dispatchAlerts = (
  response: ApiResult,
  dispatch: Function = () => {}
) => {
  if (!response?.errorTable?.length) {
    return undefined;
  }

  const messageType = response.messageType?.toLowerCase();
  let action;

  if (messageType === "info") {
    const { addToBasket, hidden } = splitApiInfoMessages(response.errorTable);
    if (hidden.length > 0) {
      console.info("[API info hidden]", hidden);
    }
    if (addToBasket.length > 0) {
      action = setInfoMessage(addToBasket);
    }
  } else if (messageType === "warning") {
    action = setWarningMessage(response.errorTable);
  }

  if (action) {
    dispatch(action);
  }

  return action;
};

export const onErroredResponse = (
  _errors: string[],
  _dispatch: Function = () => {}
) => {
  return undefined;
};
